export default __webpack_public_path__ + "static/media/fr.2b2a8790.svg";